import React from "react";

const Footer = () => (
    <footer hidden className=" py-2 bg-light">
        <div className="container px-4"><p className="m-0 text-center text-dark">Copyright &copy; Barreca 2025</p></div>
    </footer>
);

export default Footer;